import request from './http'

// 用户要求：暂时写死从该地址获取
// 使用代理 /local-api 解决跨域

export function fetchDetailData(param,flag) { // flag:前端通过teamId设置渠道
  // http.js 的 request 支持传完整 url 字符串
  if (flag){
    // 线上
    let urlBase = 'https://d11-api.galasports.com/';
    let urlPath = flag + '/team/gameReview'
    return request(urlBase + urlPath, param, 'get', true);
  }else {
    return request(`http://backend-shopping.test-galasports.com:8104/double11_pre_30/team/gameReview`, param, 'get', true)
    // return request(`/pc-api/team/gameReview`, param, 'get', true)
  }
}
// 分享发奖
export function shareGetAward(flag) {
  let param = {};
  if (flag){
    // 线上
    let urlBase = 'https://d11-api.galasports.com/';
    let urlPath = flag + '/team/shareAward'
    return request(urlBase + urlPath, param, 'get', false);
  }else {
    // 内网
    return request('http://backend-shopping.test-galasports.com:8104/double11_pre_30/team/shareAward' , param, 'get', false)
    // return request('/pc-api/team/shareAward' , param, 'get', false)
  }

}
// 邀请玩家
export function InvitePlayers(data,flag) {
  let param = data;
  if (flag){
    // 线上
    let urlBase = 'https://d11-api.galasports.com/';
    let urlPath = flag + '/team/inviteBind'
    return request(urlBase + urlPath, param, 'get', false);
  }else {
    // 内网
    return request('http://backend-shopping.test-galasports.com:8104/double11_pre_30/team/inviteBind' , param, 'get', false)
    // return request('/pc-api/team/inviteBind' , param, 'get', false)
  }

}
// 获取分享详情
export function getShareDetail(flag) {
  let param = {};
  if (flag){
    // 线上
    let urlBase = 'https://d11-api.galasports.com/';
    let urlPath = flag + '/team/shareDetail'
    return request(urlBase + urlPath, param, 'get', false);
  }else {
    // 内网
    return request('http://backend-shopping.test-galasports.com:8104/double11_pre_30/team/shareDetail' , param, 'get', false)
    // return request('/pc-api/team/shareDetail' , param, 'get', false)
  }

}
